import {RecodeLogic} from '@fantasmagames/slot/src/logic/integration/RecodeLogic';
import {BetButtonModule} from '@fantasmagames/slot/src/modules/keypad/bet/BetButtonModule';
import {FreeRoundsScreenEvents} from '@fantasmagames/slot/src/modules/microgaming/freerounds/FreeRoundsScreenEvents';

export class RecodeBetButtonModule extends BetButtonModule {
	protected _startscreenExitFinished: boolean = false;

	protected setupEvents(): void {
		super.setupEvents();

		this.on(FreeRoundsScreenEvents.FREE_GAMES_RESUMED, this.onFreegamesResumed);
		this.on(FreeRoundsScreenEvents.FREE_GAMES_STARTED, this.onFreeGamesStarted);
		this.on(FreeRoundsScreenEvents.FREE_GAMES_REJECTED, this.onFreeGamesFinished);
		this.on(FreeRoundsScreenEvents.FREE_GAMES_POSTPONED, this.onFreeGamesFinished);
		this.on(FreeRoundsScreenEvents.FREE_GAMES_FINISHED, this.onFreeGamesFinished);
		this.on(FreeRoundsScreenEvents.FREE_GAME_EXPIRED, this.onFreeGamesFinished);
	}

	protected onFreeGamesFinished(): void {
		if (!this.hasFreeGames() && this._startscreenExitFinished) {
			this.enableBetButton();
			this.showBetButton();
		}
	}

	protected onStartScreenExitFinished(): void {
		this._startscreenExitFinished = true;

		if (!this.hasFreeGames()) {
			this.showBetButton();
		}
	}

	protected onFreeGamesStarted(): void {
		if (this.hasFreeGames()) {
			this.hideBetButton();
		}
	}

	protected onFreegamesResumed(): void {
		this.hideBetButton();
	}

	public enableBetButton(): void {
		if (!(this.logic as RecodeLogic).isInFreeRounds) {
			super.enableBetButton();
		}
	}

	public showBetButton(): void {
		if (!this.hasFreeGames()) {
			super.showBetButton();
		}
	}

	protected hasFreeSpins(): boolean {
		return (this.logic as RecodeLogic).freespinsTotalAwarded > 0;
	}

	protected hasFreeGames(): boolean {
		return (this.logic as RecodeLogic).hasFreeGames();
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/keypad/bet/recode/RecodeBetButtonModule.ts